export interface WalkthroughStep {
  id: string;
  order: number;
  targetSelector: string | null;
  title: string;
  description: string;
  position: "top" | "bottom" | "left" | "right" | "center";
  type: "tooltip" | "modal";
}

export const WALKTHROUGH_STEPS: WalkthroughStep[] = [
  {
    id: "welcome",
    order: 0,
    targetSelector: null,
    title: "steps.welcome.title",
    description: "steps.welcome.description",
    position: "center",
    type: "modal",
  },
  {
    id: "sidebar",
    order: 1,
    targetSelector: '[data-tour="sidebar-nav"]',
    title: "steps.sidebar.title",
    description: "steps.sidebar.description",
    position: "right",
    type: "tooltip",
  },
  {
    id: "metrics",
    order: 2,
    targetSelector: '[data-tour="kpi-row"]',
    title: "steps.metrics.title",
    description: "steps.metrics.description",
    position: "bottom",
    type: "tooltip",
  },
  {
    id: "action-center",
    order: 3,
    targetSelector: '[data-tour="action-center"]',
    title: "steps.action-center.title",
    description: "steps.action-center.description",
    position: "top",
    type: "tooltip",
  },
  {
    id: "channels",
    order: 4,
    targetSelector: '[data-tour="sidebar-item-channels"]',
    title: "steps.channels.title",
    description: "steps.channels.description",
    position: "right",
    type: "tooltip",
  },
  {
    id: "workflows",
    order: 5,
    targetSelector: '[data-tour="sidebar-item-workflows"]',
    title: "steps.workflows.title",
    description: "steps.workflows.description",
    position: "right",
    type: "tooltip",
  },
  {
    id: "campaigns",
    order: 6,
    targetSelector: '[data-tour="sidebar-item-campaigns"]',
    title: "steps.campaigns.title",
    description: "steps.campaigns.description",
    position: "right",
    type: "tooltip",
  },
  {
    id: "conversations",
    order: 7,
    targetSelector: '[data-tour="sidebar-item-conversations"]',
    title: "steps.conversations.title",
    description: "steps.conversations.description",
    position: "right",
    type: "tooltip",
  },
  {
    id: "analytics",
    order: 8,
    targetSelector: '[data-tour="sidebar-item-analytics"]',
    title: "steps.analytics.title",
    description: "steps.analytics.description",
    position: "right",
    type: "tooltip",
  },
  {
    id: "complete",
    order: 9,
    targetSelector: null,
    title: "steps.complete.title",
    description: "steps.complete.description",
    position: "center",
    type: "modal",
  },
];
